export const dropdownMenuStyle = dark => ({
  background: dark ? '#23272b' : '#fff',
  color: dark ? '#f8f9fa' : '#212529',
  border: dark ? '1px solid #343a40' : undefined,
  minWidth: 180,
});

export const dropdownToggleStyle = dark => ({
  color: dark ? '#f8f9fa' : '#212529',
  background: dark ? '#343a40' : '#fff',
  border: dark ? '1px solid #343a40' : undefined,
});

export const dropdownMenuContainerStyle = (dark) => ({
  maxHeight: 'calc(100vh - 200px)',
  overflowY: 'auto',
});

export const dropdownItemStyle = (dark, isActive = false, isHovered = false) => {
  let style = {
    color: dark ? '#f8f9fa' : '#212529',
    background: dark ? '#23272b' : '#fff',
    cursor: 'pointer',
    transition: 'background 0.2s,color 0.2s',
  };

  if (isActive) {
    style = {
      ...style,
      background: dark ? '#23272b' : '#e7f1ff',
      color: dark ? '#f8f9fa' : '#0d6efd',
      fontWeight: 600,
    };
  } else if (isHovered) {
    style = {
      ...style,
      background: dark ? '#343a40' : '#f0f4fa',
      color: dark ? '#fff' : '#0d6efd',
    };
  }

  return style;
};